"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PotencyFilterOptions = void 0;
const products_1 = require("@getgreenline/products");
const RangeFilterOption_1 = require("../../filterOptions/CannabinoidsFilterOption/RangeFilterOption");
const UnitFilterOption_1 = require("../../filterOptions/CannabinoidsFilterOption/UnitFilterOption");
const mobx_1 = require("mobx");
class PotencyFilterOptions {
    constructor() {
        this.potencyFilters = {
            abvFilterOption: new RangeFilterOption_1.RangeFilterOption({
                singleValueKey: products_1.MetaDataModels.MetaDataReservedKeys.ABV,
                minValueKey: products_1.MetaDataModels.MetaDataReservedKeys.MIN_ABV,
                maxValueKey: products_1.MetaDataModels.MetaDataReservedKeys.MAX_ABV,
                potencyType: products_1.PotencyModels.PotencyType.ABV,
            }),
            proofFilterOption: new RangeFilterOption_1.RangeFilterOption({
                singleValueKey: products_1.MetaDataModels.MetaDataReservedKeys.PROOF,
                minValueKey: products_1.MetaDataModels.MetaDataReservedKeys.MIN_PROOF,
                maxValueKey: products_1.MetaDataModels.MetaDataReservedKeys.MAX_PROOF,
                potencyType: products_1.PotencyModels.PotencyType.PROOF,
            }),
            thcFilterOption: new RangeFilterOption_1.RangeFilterOption({
                singleValueKey: products_1.MetaDataModels.MetaDataReservedKeys.THC,
                minValueKey: products_1.MetaDataModels.MetaDataReservedKeys.MIN_THC,
                maxValueKey: products_1.MetaDataModels.MetaDataReservedKeys.MAX_THC,
                potencyType: products_1.PotencyModels.PotencyType.THC,
            }),
            cbdFilterOption: new RangeFilterOption_1.RangeFilterOption({
                singleValueKey: products_1.MetaDataModels.MetaDataReservedKeys.CBD,
                minValueKey: products_1.MetaDataModels.MetaDataReservedKeys.MIN_CBD,
                maxValueKey: products_1.MetaDataModels.MetaDataReservedKeys.MAX_CBD,
                potencyType: products_1.PotencyModels.PotencyType.CBD,
            }),
            pgFilterOption: new RangeFilterOption_1.RangeFilterOption({
                singleValueKey: products_1.MetaDataModels.MetaDataReservedKeys.PG,
                minValueKey: products_1.MetaDataModels.MetaDataReservedKeys.MIN_PG,
                maxValueKey: products_1.MetaDataModels.MetaDataReservedKeys.MAX_PG,
                potencyType: products_1.PotencyModels.PotencyType.PG,
            }),
            vgFilterOption: new RangeFilterOption_1.RangeFilterOption({
                singleValueKey: products_1.MetaDataModels.MetaDataReservedKeys.VG,
                minValueKey: products_1.MetaDataModels.MetaDataReservedKeys.MIN_VG,
                maxValueKey: products_1.MetaDataModels.MetaDataReservedKeys.MAX_VG,
                potencyType: products_1.PotencyModels.PotencyType.VG,
            }),
            nicotineStrengthFilterOption: new RangeFilterOption_1.RangeFilterOption({
                singleValueKey: products_1.MetaDataModels.MetaDataReservedKeys.NICOTINE_STRENGTH,
                minValueKey: products_1.MetaDataModels.MetaDataReservedKeys.MIN_NICOTINE_STRENGTH,
                maxValueKey: products_1.MetaDataModels.MetaDataReservedKeys.MAX_NICOTINE_STRENGTH,
                potencyType: products_1.PotencyModels.PotencyType.NICOTINE_STRENGTH,
            }),
        };
        this.unitFilterOption = new UnitFilterOption_1.UnitFilterOption();
    }
    reset() {
        Object.values(this.potencyFilters).forEach((filter) => filter.reset());
        this.unitFilterOption.reset();
    }
    get isSet() {
        return Object.values(this.potencyFilters).some((filter) => filter.isSet);
    }
    isProductMetaDataInRange(productMetaData) {
        return Object.values(this.potencyFilters).every((filter) => {
            if (!filter.isSet)
                return true;
            return filter.isInRange(productMetaData) && this.unitFilterOption.isMatching(productMetaData);
        });
    }
    isBatchMetaDataInRange(batch, productMetaData) {
        const metaDataHash = {};
        batch.cannabinoidMetaData[0].metaData.forEach((item) => {
            if (item.metaKey && item.metaValue) {
                metaDataHash[item.metaKey] = item.metaValue;
            }
        });
        // Check if UNIT metaKey is present in the batch metaData
        // TODO: remove it after GR-8429 is completed
        // https://blazesolutions.atlassian.net/browse/GR-8429
        const hasUnitKey = products_1.MetaDataModels.MetaDataReservedKeys.UNIT in metaDataHash;
        const hasUnitValue = hasUnitKey && metaDataHash[products_1.MetaDataModels.MetaDataReservedKeys.UNIT];
        if (!hasUnitKey || !hasUnitValue) {
            metaDataHash[products_1.MetaDataModels.MetaDataReservedKeys.UNIT] = products_1.UnitModels.ThcCbdUnit.PERCENT;
        }
        return Object.values(this.potencyFilters).every((filter) => {
            if (!filter.isSet)
                return true;
            const batchMetaDataHasPotencyFilter = batch.cannabinoidMetaData[0].metaData.some((MD) => {
                const lowerCasedMetaKey = MD.metaKey.toLowerCase();
                const lowerCasedSingleValueKey = filter.singleValueKey.toLowerCase();
                return lowerCasedMetaKey.includes(lowerCasedSingleValueKey) && MD.metaValue;
            });
            const targetMetaData = batchMetaDataHasPotencyFilter ? metaDataHash : productMetaData;
            return filter.isInRange(targetMetaData) && this.unitFilterOption.isMatching(targetMetaData);
        });
    }
    buildLabel() {
        const labels = [];
        for (const filter of Object.values(this.potencyFilters)) {
            if (!filter.isSet)
                continue;
            const rangeMessage = filter.rangeMessage(this.unitFilterOption.unit);
            labels.push(rangeMessage ? `${filter.singleValueKey} (${rangeMessage})` : filter.singleValueKey);
        }
        return labels.join(' - ');
    }
    getMinValueKey(potencyType) {
        switch (potencyType) {
            case products_1.PotencyModels.PotencyType.ABV:
                return this.potencyFilters.abvFilterOption.minValueKey;
            case products_1.PotencyModels.PotencyType.PROOF:
                return this.potencyFilters.proofFilterOption.minValueKey;
            case products_1.PotencyModels.PotencyType.THC:
                return this.potencyFilters.thcFilterOption.minValueKey;
            case products_1.PotencyModels.PotencyType.CBD:
                return this.potencyFilters.cbdFilterOption.minValueKey;
            case products_1.PotencyModels.PotencyType.PG:
                return this.potencyFilters.pgFilterOption.minValueKey;
            case products_1.PotencyModels.PotencyType.VG:
                return this.potencyFilters.vgFilterOption.minValueKey;
            case products_1.PotencyModels.PotencyType.NICOTINE_STRENGTH:
                return this.potencyFilters.nicotineStrengthFilterOption.minValueKey;
        }
    }
    getMaxValueKey(potencyType) {
        switch (potencyType) {
            case products_1.PotencyModels.PotencyType.ABV:
                return this.potencyFilters.abvFilterOption.maxValueKey;
            case products_1.PotencyModels.PotencyType.PROOF:
                return this.potencyFilters.proofFilterOption.maxValueKey;
            case products_1.PotencyModels.PotencyType.THC:
                return this.potencyFilters.thcFilterOption.maxValueKey;
            case products_1.PotencyModels.PotencyType.CBD:
                return this.potencyFilters.cbdFilterOption.maxValueKey;
            case products_1.PotencyModels.PotencyType.PG:
                return this.potencyFilters.pgFilterOption.maxValueKey;
            case products_1.PotencyModels.PotencyType.VG:
                return this.potencyFilters.vgFilterOption.maxValueKey;
            case products_1.PotencyModels.PotencyType.NICOTINE_STRENGTH:
                return this.potencyFilters.nicotineStrengthFilterOption.maxValueKey;
        }
    }
    getSingleValueKey(potencyType) {
        switch (potencyType) {
            case products_1.PotencyModels.PotencyType.ABV:
                return this.potencyFilters.abvFilterOption.singleValueKey;
            case products_1.PotencyModels.PotencyType.PROOF:
                return this.potencyFilters.proofFilterOption.singleValueKey;
            case products_1.PotencyModels.PotencyType.THC:
                return this.potencyFilters.thcFilterOption.singleValueKey;
            case products_1.PotencyModels.PotencyType.CBD:
                return this.potencyFilters.cbdFilterOption.singleValueKey;
            case products_1.PotencyModels.PotencyType.PG:
                return this.potencyFilters.pgFilterOption.singleValueKey;
            case products_1.PotencyModels.PotencyType.VG:
                return this.potencyFilters.vgFilterOption.singleValueKey;
            case products_1.PotencyModels.PotencyType.NICOTINE_STRENGTH:
                return this.potencyFilters.nicotineStrengthFilterOption.singleValueKey;
        }
    }
}
exports.PotencyFilterOptions = PotencyFilterOptions;
__decorate([
    mobx_1.action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], PotencyFilterOptions.prototype, "reset", null);
__decorate([
    mobx_1.computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PotencyFilterOptions.prototype, "isSet", null);
//# sourceMappingURL=PotencyFilterOptions.js.map